import { ArbitrationCards, ArbitrationDecisionPayload, ArbitrationQueueRow } from './types';

const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();
  if (!res.ok || json.failure) throw new Error(json.em || json.message || 'Request failed');
  return json;
};

const rows = (json: any) => {
  const sd = json.sd || json.result?.sd || json.data?.sd;
  return Array.isArray(sd) ? sd : [];
};

export const generateArbitrationSession = async (scenarioCode: string, pressureId: number | null, name: string) => {
  return postBiz({ s: 'budgetarbitration', a: 'generate', scc: scenarioCode, bpi: pressureId, nam: name || null });
};

export const runArbitrationRecommendations = async (sessionId: number) => {
  return postBiz({ s: 'budgetarbitration', a: 'recommend', rid: sessionId });
};

export const fetchArbitrationCards = async (sessionId: number): Promise<ArbitrationCards> => {
  const json = await postBiz({ s: 'budgetarbitration', a: 'cards', rid: sessionId });
  return json.sd || json.result || json;
};

export const fetchArbitrationQueue = async (sessionId: number, sourceCode = '', decisionCode = ''): Promise<ArbitrationQueueRow[]> => {
  const json = await postBiz({ s: 'budgetarbitration', a: 'queue', rid: sessionId, src: sourceCode || null, dcc: decisionCode || null });
  return rows(json);
};

export const decideArbitrationItem = async (payload: ArbitrationDecisionPayload) => {
  return postBiz({ s: 'budgetarbitration', a: 'decide', rid: payload.rid, dcc: payload.dcc, amt: payload.amt, dcr: payload.dcr });
};
